import AlbusApis from "./albus/AlbusApis"
import { IAlbusApis } from "./albus/IAlbusApis"
import InternalApis from "./internal/InternalApis"
import { IInternalApis } from "./internal/IInternalApis"
import PolarisApis from "./polaris/PolarisApis"
import { IPolarisApis } from "./polaris/IPolarisApis"
import MaverickApis from "./maverick/MaverickApis"
import { IMaverickApis } from "./maverick/IMaverickApis"
import { IMetricServiceApis } from "./metricService/IMetricServiceApis"
import MetricServiceApis from "./metricService/MetricServiceApis"
import OllivanderApis from "./ollivander/OllivanderApis"
import EHRApis from "./ehr/EHRApis"
import { IEHRApis } from "./ehr/IEHRApis"
import { IUserFitnessApis } from "./userFitness/IUserFitnessApis"
import UserFitnessApis from "./userFitness/UserFitnessApis"
import { IShifuServiceApis } from "./shifu/IShifuServiceApis"
import ShifuServiceApis from "./shifu/ShifuServiceApis"
import { IDiyFsServiceApis } from "./diyFs/IDiyFsServiceApis"
import DiyFsServiceApis from "./diyFs/DiyFsServiceApis"
import { IAmbrosiaServiceApis } from "./ambrosia/IAmbrosiaServiceApis"
import AmbrosiaServiceApis from "./ambrosia/AmbrosiaServiceApis"
import { ICHSServiceApis } from "./chs/ICHSServiceApis"
import CHSServiceApis from "./chs/CHSServiceApis"
import { IIrisServiceApis } from "./iris/IIrisServiceApis"
import IrisServiceApis from "./iris/IrisServiceApis"
import SubscriptionManagerApis from "./subscriptionManager/SubscriptionManagerApi"
import { INestService } from "./nest/INestService"
import NestServiceApis from "./nest/NestServiceApis"
import { IOdinService } from "./odin/IOdinService"
import OdinServiceApis from "./odin/OdinServiceApis"
import CMSServiceApis from "./cms/CMSServiceApis"
import { ICMSService } from "./cms/ICMSService"
import { IHouseMdService } from "./houseMD/IHouseMdService"
import HouseMdServiceApis from "./houseMD/HouseMdServiceApis"
import FuseServiceApis from "./fuse/FuseServiceApis"
import { IFuseService } from "./fuse/IFuseService"
import LmsServiceApis from "./lms/LmsServiceApis"
import { ILmsService } from "./lms/ILmsService"
import ConverseApis from "./converse/ConverseApis"
import { IConverseApis } from "./converse/IConverseApis"
import IndusServiceApis from "./indus/IndusServiceApis"
import { IIndusService } from "./indus/IIndusService"
import { ISubuserApis } from "./subUser/ISubuserApis"
import SubuserApis from "./subUser/SubuserApis"
import { IUserServiceApis } from "./userService/IUserServiceApis"
import UserServiceApis from "./userService/UserServiceApis"
import { IAlfredServiceApis } from "./alfred/IAlfredServiceApis"
import AlfredServiceApis from "./alfred/AlfredServiceApis"
import { IOllivanderApis } from "./ollivander/IOllivanderApis"
import { ICareRecommendationApis } from "./careRecommendation/ICareRecommendationApis"
import CareRecommendationApis from "./careRecommendation/CareRecommendationApis"
import { ISubscriptionManagerApis } from "./subscriptionManager/ISubscriptionManagerApi"
import { IAppConfigServiceApis } from "./appConfig/IAppConfigServiceApis"
import AppConfigServiceApis from "./appConfig/AppConfigService"
import { ISkynetService } from "./skynet/ISkynetService"
import SkynetServiceApis from "./skynet/SkynetServiceApis"
import { IOmsService } from "./oms/IOmsService"
import OmsServiceApis from "./oms/OmsServiceApis"
import { ISegmentationService } from "./segmentationService/ISegmentationService"
import SegmentationServiceApis from "./segmentationService/SegmentationServiceApis"
import ConfigStoreServiceApis from "./configStore/ConfigStoreServiceApis"
import { IConfigStoreService } from "./configStore/IConfgiStoreService"

export class ApiManager {
	public static readonly albusApis: IAlbusApis = new AlbusApis()
	public static readonly alfredApis: IAlfredServiceApis = new AlfredServiceApis()
	public static readonly internalApis: IInternalApis = new InternalApis()
	public static readonly polarisApis: IPolarisApis = new PolarisApis()
	public static readonly maverickApis: IMaverickApis = new MaverickApis()
	public static readonly metricServiceApis: IMetricServiceApis = new MetricServiceApis()
	public static readonly ollivanderServiceApis: IOllivanderApis = new OllivanderApis()
	public static readonly ehrServiceApis: IEHRApis = new EHRApis()
	public static readonly userFitnessApis: IUserFitnessApis = new UserFitnessApis()
	public static readonly shifuServiceApis: IShifuServiceApis = new ShifuServiceApis()
	public static readonly diyFsServiceApis: IDiyFsServiceApis = new DiyFsServiceApis()
	public static readonly ambrosiaServiceApis: IAmbrosiaServiceApis = new AmbrosiaServiceApis()
	public static readonly chsServiceApis: ICHSServiceApis = new CHSServiceApis()
	public static readonly userServiceApis: IUserServiceApis = new UserServiceApis()
	public static readonly irisServiceApis: IIrisServiceApis = new IrisServiceApis()
	public static readonly subscriptionManagerApis: ISubscriptionManagerApis = new SubscriptionManagerApis()
	public static readonly nestServiceApis: INestService = new NestServiceApis()
	public static readonly odinServiceApis: IOdinService = new OdinServiceApis()
	public static readonly cmsServiseApis: ICMSService = new CMSServiceApis()
	public static readonly houseMdServiceApis: IHouseMdService = new HouseMdServiceApis()
	public static readonly fuseServiceApis: IFuseService = new FuseServiceApis()
	public static readonly lmsServiceApis: ILmsService = new LmsServiceApis()
	public static readonly converseApis: IConverseApis = new ConverseApis()
	public static readonly indusServiceApis: IIndusService = new IndusServiceApis()
	public static readonly subUserServiceApis: ISubuserApis = new SubuserApis()
	public static readonly careRecommendationApis: ICareRecommendationApis = new CareRecommendationApis()
	public static readonly omsApis: IOmsService = new OmsServiceApis()
	public static readonly appConfigServiceApis: IAppConfigServiceApis = new AppConfigServiceApis()
	public static readonly skynetServiceApis: ISkynetService = new SkynetServiceApis()
	public static readonly omsServiceApis: IOmsService = new OmsServiceApis()
	public static readonly segmentationServiceApis: ISegmentationService = new SegmentationServiceApis()
	public static readonly configStoreServiceApis = new ConfigStoreServiceApis()
	public static getAlbusApis(): IAlbusApis {
		return ApiManager.albusApis
	}

	public static getAlfredApis(): IAlfredServiceApis {
		return ApiManager.alfredApis
	}

	public static getInternalApis(): IInternalApis {
		return ApiManager.internalApis
	}

	public static getPolarisApis(): IPolarisApis {
		return ApiManager.polarisApis
	}

	// public static getRamsayApis(): IRamsayApis {
	// 	return ApiManager.ramsayApis;
	// }

	public static getMaverickApis(): IMaverickApis {
		return ApiManager.maverickApis
	}

	public static getMetricServiceApis(): IMetricServiceApis {
		return ApiManager.metricServiceApis
	}

	public static getSubUserServiceApis(): ISubuserApis {
		return ApiManager.subUserServiceApis
	}

	public static getOllivanderServiceApis() {
		return ApiManager.ollivanderServiceApis
	}

	public static getEHRApis(): IEHRApis {
		return ApiManager.ehrServiceApis
	}

	public static getCareRecommendationServiceApis(): ICareRecommendationApis {
		return ApiManager.careRecommendationApis
	}

	public static getUserFitnessApis(): IUserFitnessApis {
		return ApiManager.userFitnessApis
	}
	public static getShifuServiceApis(): IShifuServiceApis {
		return ApiManager.shifuServiceApis
	}
	public static getDiyFsServiceApis(): IDiyFsServiceApis {
		return ApiManager.diyFsServiceApis
	}

	public static getAmbrosiaServiceApis(): IAmbrosiaServiceApis {
		return ApiManager.ambrosiaServiceApis
	}

	public static getCHSServiceApis(): ICHSServiceApis {
		return ApiManager.chsServiceApis
	}

	public static getUserServiceApis(): IUserServiceApis {
		return ApiManager.userServiceApis
	}

	public static getIrisServiceApis(): IIrisServiceApis {
		return ApiManager.irisServiceApis
	}

	public static getSubscriptionManagerApis(): ISubscriptionManagerApis {
		return ApiManager.subscriptionManagerApis
	}

	public static getNestServiceApis(): INestService {
		return ApiManager.nestServiceApis
	}

	public static getOdinServiceApis(): IOdinService {
		return ApiManager.odinServiceApis
	}

	public static getCmsServiceApis(): ICMSService {
		return ApiManager.cmsServiseApis
	}

	public static getFuseServiceApis(): IFuseService {
		return ApiManager.fuseServiceApis
	}

	public static getLmsServiceApis(): ILmsService {
		return ApiManager.lmsServiceApis
	}

	public static getHouseMdServiceApis(): IHouseMdService {
		return ApiManager.houseMdServiceApis
	}

	public static getConverseApis(): IConverseApis {
		return ApiManager.converseApis
	}

	public static getIndusServiceApis(): IIndusService {
		return ApiManager.indusServiceApis
	}

	public static getAppConfigServiceApis(): IAppConfigServiceApis {
		return ApiManager.appConfigServiceApis
	}

	public static getOmsServiceApis(): IOmsService {
		return ApiManager.omsServiceApis
	}

	public static getSegmentationServiceApis(): ISegmentationService {
		return ApiManager.segmentationServiceApis
	}

	public static getSkynetServiceApis(): ISkynetService {
		return ApiManager.skynetServiceApis
	}

	public static getConfigStoreServiceApis(): IConfigStoreService {
		return ApiManager.configStoreServiceApis
	}
}
